/**
 * The RaffleUnlock container
 */
import { ConnectWallet } from "@bkry/bowline-components/ConnectWallet";
import { SignInWithEthereumButton } from "@bkry/bowline-components/SignInWithEthereumButton";
import { UnlockButton } from "@bkry/bowline-components/UnlockButton";
import { UnlockTokenSelector } from "@bkry/bowline-components/UnlockTokenSelector";
import { ScrollToTop as useScrollToTop } from "@bkry/bowline-components/Utils";
import { getProjectAttributes } from "@bkry/bowline-redux/projects";
import {
  getUnlockableContentAttributes,
  getUnlockableContentRelationships,
  prepareUnlockUnlockableContent,
  showUnlockableContent,
  unlockUnlockableContent,
} from "@bkry/bowline-redux/unlockableContents";
import { getWalletAttributes } from "@bkry/bowline-redux/wallets";
import { env } from "@bkry/bowline-utils";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "reactstrap";
import Page from "../components/Page/Page-component";
import RaffleWinnerAnnouncement from "../components/RaffleWinnerAnnouncement";
const { REACT_APP_PROJECT_ID } = env;

// DEV
// const REACT_APP_RAFFLE_WINNER_UNLOCKABLE =
//   "5cbe78b6-e7fb-4e8b-93dd-5318744059e7";

const REACT_APP_RAFFLE_WINNER_UNLOCKABLE =
  "b4feace5-20a5-44d0-bd65-151fe0c2fff7";
/**
 * RaffleUnlock container, the landing page for logged in users
 */
const RaffleUnlock = (props, context) => {
  useScrollToTop();
  const dispatch = useDispatch();
  const [tokenSelectorOpen, toggleTokenSelector] = useState(false);
  const { account, provider, connector } = useWeb3React();
  const wallet = useSelector((state) => getWalletAttributes(state, account));

  const dispatchApi = async () => {
    dispatch(
      showUnlockableContent({
        projectId: REACT_APP_PROJECT_ID,
        id: REACT_APP_RAFFLE_WINNER_UNLOCKABLE,
      })
    );
  };

  useEffect(dispatchApi, [dispatch, wallet, account]);

  const projectData = useSelector((state) =>
    getProjectAttributes(state, REACT_APP_PROJECT_ID)
  );

  const unlockableContent = useSelector((state) =>
    getUnlockableContentAttributes(state, REACT_APP_RAFFLE_WINNER_UNLOCKABLE)
  );

  const unlockableContentRelationships = useSelector((state) =>
    getUnlockableContentRelationships(state, REACT_APP_RAFFLE_WINNER_UNLOCKABLE)
  );

  const unlockContent = (tokens, unlockInputsValues = undefined) => {
    if (unlockableContent) {
      dispatch(
        prepareUnlockUnlockableContent({
          account,
          connector,
          provider,
          title: unlockableContent?.title,
          project_title: projectData?.title,
          // unlock_boundary_id: 1, // If only one unlock boundary exists we ignore this, if multiple we check which one matches
          token_identifier: tokens[0].identifier,
          contract_address: tokens[0].contract_address,
          callbackSuccess: ({
            signature,
            token_identifier,
            contract_address,
            unlock_boundary_id,
          }) => {
            dispatch(
              unlockUnlockableContent({
                signature,
                token_identifier,
                contract_address,
                id: REACT_APP_RAFFLE_WINNER_UNLOCKABLE,
                project_id: REACT_APP_PROJECT_ID,
                unlock_boundary_id,
                unlock_input_values: unlockInputsValues,
                callbackSuccess: () => {
                  console.log("Successfully unlocked");
                },
              })
            );
          },
        })
      );
    }
  };

  let unlockInputIdsArray = [];

  unlockableContentRelationships?.unlock_inputs?.data.map((inputId) =>
    unlockInputIdsArray.push(inputId)
  );

  return (
    <Page id="raffle-unlock" title="Raffle Unlock" className="mb-5">
      <Container>
        <RaffleWinnerAnnouncement hideButton />
        {unlockableContent && (
          <>
            <h2>{unlockableContent.title}</h2>
            {unlockableContent?.public_description && (
              <div
                className="mb-3"
                dangerouslySetInnerHTML={{
                  __html: unlockableContent.public_description.replace(
                    /href=/g,
                    " target='_blank' rel='noopener noreferrer' href="
                  ),
                }}
              />
            )}
            {unlockableContent?.secret_description && (
              <div
                className="alert alert-success"
                dangerouslySetInnerHTML={{
                  __html: unlockableContent.secret_description.replace(
                    /href=/g,
                    " target='_blank' rel='noopener noreferrer' href="
                  ),
                }}
              />
            )}
            {account && wallet && (
              <>
                {unlockableContent?.user_abilities?.can_unlock ? (
                  <UnlockButton
                    confirmedEmailRequired={
                      unlockableContent?.confirmed_email_required
                    }
                    toggleTokenSelector={toggleTokenSelector}
                    color="primary"
                    className="my-3 w-100"
                  >
                    {context.t("Unlock")}
                  </UnlockButton>
                ) : (
                  <p>
                    {context.t(
                      "Your wallet does not contain a token that can unlock this content. Maybe the token has already been used?"
                    )}
                  </p>
                )}
              </>
            )}
            {tokenSelectorOpen && (
              <UnlockTokenSelector
                isOpen={tokenSelectorOpen}
                toggleModal={toggleTokenSelector}
                unlockableContentId={REACT_APP_RAFFLE_WINNER_UNLOCKABLE}
                confirmUnlockFeedbackFunction={unlockContent}
                unlockInputIdsArray={unlockInputIdsArray}
              />
            )}
          </>
        )}
        {!account && (
          <ConnectWallet
            buttonColor="primary"
            buttonSize="xl"
            buttonId="nav-connect-wallet"
            block
          />
        )}
        {account && !wallet && (
          <SignInWithEthereumButton
            color="primary"
            size="xl"
            block
            onSuccess={() => {}}
          />
        )}
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
RaffleUnlock.contextTypes = {
  t: PropTypes.func,
};

RaffleUnlock.propTypes = {
  mintTierId: PropTypes.string,
};

/** export the component as redux connected component */
export default RaffleUnlock;
